import { Component, Input, OnInit, OnChanges, SimpleChanges, signal, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponentV2 } from '../../../../../../shared/components/icon-component/icon.component';
import { WhitelabelChatMessage, WhitelabelChatService, WhitelabelChatSource, WhitelabelChatSourcesData } from '../../../../../../core/services/whitelabel-chat.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-analysis',
  standalone: true,
  imports: [CommonModule, IconComponentV2],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './analysis.component.html'
})
export class AnalysisComponent implements OnInit, OnChanges {
  private chatService = inject(WhitelabelChatService);

  @Input() botId: number | null = null;
  private lastFetchedId: number | null = null;

  isLoading = signal(false);
  data = signal<WhitelabelChatSourcesData | null>(null);

  totalSessions = computed(() => {
    const d = this.data();
    if (!d) return 0;
    return d.sources.reduce((acc, s) => acc + s.sessionCount, 0);
  });

  ngOnInit() {
    if (this.botId) {
      this.fetchAnalysis(this.botId);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['botId'] && !changes['botId'].firstChange) {
      const newId = changes['botId'].currentValue;
      if (newId) {
        this.fetchAnalysis(newId);
      } else {
        this.data.set(null);
      }
    }
  }

  fetchAnalysis(botId: number) {
    if (this.lastFetchedId === botId) return;
    this.lastFetchedId = botId;

    this.isLoading.set(true);
    this.chatService.getChatbotSources(botId)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.data.set(res.data);
          }
        },
        error: (err) => {
          console.error('Failed to fetch analysis:', err);
          this.data.set(null);
        }
      });
  }

  openSessionBrowser(source: WhitelabelChatSource) {
    if (!this.botId) return;
    this.chatService.openAnalysisDrawer(source, this.botId);
  }

  getPercent(value: number, total: number): number {
    if (!total) return 0;
    return (value / total) * 100;
  }
}
